import axios from 'axios'

import { type DocusealTemplateRequest } from '@flecto/types'

/** Create Docuseal template from PDF on Docuseal (via API).
 *
 * @endpoint POST https://api.docuseal.com/templates/pdf
 * @scope shared
 */
export async function createDocumentTemplateFromPdfOnDocuseal(payload: DocusealTemplateRequest) {
  const response = await axios.post(
    'https://api.docuseal.com/templates/pdf',
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': process.env.DOCUSEAL_TOKEN ?? '',
      },
    }
  )

  return response.data
}
